import { type VariantProps, cva } from "class-variance-authority";
import clsx from "clsx";
import type { PropsWithChildren } from "react";

import { Typography } from "@/components/ui/text/Typography/Typography";

export const radioOrCheckbox = cva("flex items-center justify-center border-2", {
  variants: {
    variant: {
      default: [
        "border-interactive-icon-idle",
        "group-disabled:border-interactive-icon-disabled",
        "group-hover:border-interactive-icon-hover",
        "group-pressed:border-interactive-icon-pressed",
        "group-selected:border-interactive-icon-toggled",
        "group-selected:bg-interactive-icon-toggled",
        "group-selected:group-hover:bg-interactive-icon-hover",
        "group-selected:group-hover:border-interactive-icon-hover",
        "group-selected:group-pressed:bg-interactive-icon-pressed",
        "group-selected:group-pressed:border-interactive-icon-pressed",
        "group-indeterminate:border-interactive-icon-toggled",
        "group-indeterminate:bg-interactive-icon-toggled",
        "group-indeterminate:group-hover:bg-interactive-icon-hover",
        "group-indeterminate:group-hover:border-interactive-icon-hover",
        "group-indeterminate:group-pressed:bg-interactive-icon-pressed",
        "group-indeterminate:group-pressed:border-interactive-icon-pressed",
      ],
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

export type RadioOrCheckboxVariantProps = VariantProps<typeof radioOrCheckbox>;

export const radioOrCheckboxIndicatorClass = "group flex items-center gap-2";

export interface RadioOrCheckboxLabelProps extends PropsWithChildren {
  className?: string;
}

export const RadioOrCheckboxLabel = ({ children, className }: RadioOrCheckboxLabelProps) => {
  return (
    <Typography
      className={clsx("text-text-default-tertiary group-selected:text-interactive-icon-pressed", className)}
      size="label-4"
      variant="prominent-1"
    >
      {children}
    </Typography>
  );
};
